import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { DateRange } from '../../lib/types/DateRange'
import dayjs from 'dayjs'

type PersistedDateRangeStore = {
  dateRange: DateRange
  setDateRange: (dateRange: DateRange) => void
}

export const usePersistedDateRange = create<PersistedDateRangeStore>()(
  persist(
    (set, get) => ({
      dateRange: {
        dateRange: {
          startDate:
            dayjs().get('D') > 3
              ? dayjs().startOf('month').format('YYYY-MM-DD')
              : dayjs().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
          endDate:
            dayjs().get('D') > 3
              ? dayjs().startOf('day').format('YYYY-MM-DD')
              : dayjs().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
        },
      },
      setDateRange: (dateRange: DateRange) => set({ dateRange }),
    }),
    {
      name: 'dateRange',
    },
  ),
)

export const useDateRange = (): {
  dateRange: DateRange
  setDateRange: (dateRange: DateRange) => void
} => {
  const { dateRange, setDateRange } = usePersistedDateRange((state) => state)
  return {
    dateRange: dateRange,
    setDateRange: setDateRange,
  }
}
